export default __webpack_public_path__ + "static/media/June2009.e9ba2328.png";